import React, {Fragment, Component} from 'react';
import {Col, Row, Button, Form, FormGroup, Label, Input} from 'reactstrap';
import { Link } from 'react-router-dom';
// Layout

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setRecoveryMailAction } from '../../../reducers/ui/forgotPassword';
import { apiSendPasswordRecoveryMailAction } from '../../../sagas/apiCallSaga';
import BlockUi from 'react-block-ui';
import Loader from 'react-loaders';
import { checkUIBlock } from '../../../utils/service';
import { API_LIST } from '../../../utils/api';

const mapStateToProps = store => ({
    state: store.ui.forgotPassword,
    apiCallData: store.apiCallData
})

const mapDispatchToProps = dispatch => (
    bindActionCreators({
        setEmail: setRecoveryMailAction,
        sendRecoveryMail: apiSendPasswordRecoveryMailAction,
    }, dispatch)
)

class ForgotPasswordBoxed extends Component {

    btnRecoverClicked = () => {
        this.props.sendRecoveryMail(this.props.state.email)
    }

    render() {

        let { apiCallData } = this.props

        return (
            <Fragment>
                <div className="h-100 bg-plum-plate bg-animation">
                    <div className="d-flex h-100 justify-content-center align-items-center">
                        <Col md="6" className="mx-auto app-login-box">
                            <div className="app-logo-inverse mx-auto mb-3"/>
                                <div className="modal-dialog w-100">
                                    <BlockUi
                                        tag="div"
                                        blocking={
                                            checkUIBlock(apiCallData[API_LIST.SEND_RECOVERY_MAIL.ID])
                                        }
                                        className="block-overlay-dark"
                                        loader={<Loader color="#ffffff" active type={"ball-spin-fade-loader"}/>}
                                    >
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <div className="h5 modal-title">
                                                Forgot your Password?
                                                <h6 className="mt-1 mb-0 opacity-8">
                                                    <span>Use the form below to recover it.</span>
                                                </h6>
                                            </div>
                                        </div>
                                        <div className="modal-body">
                                            <div>
                                                <Form>
                                                    <Row form>
                                                        <Col md={12}>
                                                            <FormGroup>
                                                                <Label for="exampleEmail">Email</Label>
                                                                <Input type="email" name="email" id="exampleEmail"
                                                                    placeholder="Email here..."
                                                                    value={this.props.state.email}
                                                                    onChange={e => this.props.setEmail(e.target.value)}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                </Form>
                                            </div>
                                            <div className="divider"/>
                                            <h6 className="mb-0">
                                                <Link to="/pages/login-boxed" className="text-primary">Sign in existing account</Link>
                                            </h6>
                                        </div>
                                        <div className="modal-footer clearfix">
                                            <div className="float-right">
                                                <Button color="primary" size="lg"
                                                    onClick={this.btnRecoverClicked}
                                                >
                                                    Recover Password
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </BlockUi>
                            </div>
                            
                            <div className="text-center text-white opacity-8 mt-3">
                                Copyright &copy; CyberSPF 2020
                            </div>
                        </Col>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ForgotPasswordBoxed);